import styles from "./accountlist.module.css";
import Helmet from "react-helmet";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { ArrowLeft, Home, X } from "react-feather";
import Footer from "../../../components/Footer";
import { useState, useEffect } from "react";
import AddTuyaAccount from "./components/AddTuyaAccount";
import EditTuyaAccount from "./components/EditTuyaAccount";
import Loader from "../../../components/Loader";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import AccountListFilter from "./components/AccountListFilter";
import AccountListCard from "./components/AccountListCard";
import axios from "axios";
import { TableLoader } from "../../../components/LoaderC";
import { AddLogCallAPI } from "../../../components/AddLogs";
import { toast } from 'react-smart-toaster';
import AddDeviceFormNew from "../AddComponent/AddDeviceFormNew";

const AccountList = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [showTuyaAddFormNew, setShowTuyaAddFormNew] = useState(false);
    const [showTuyaEditFormNew, setShowTuyaEditFormNew] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [allData, setAllData] = useState([]);
    const [fileredData, setFileredData] = useState([]);
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(8);
    const [selectedData, setSelectedData] = useState(null);
    const [propertyList, setPropertyList] = useState([]);
    const [filterData, setFilterData] = useState({ searchKey: "", property: "", apartment: "", type: "" });
    const [showAddFormNew, setShowAddFormNew] = useState(false);
    const [apartmentData, setApartmentData] = useState(null);

    useEffect(() => {
        const fetchAllProperties = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_DEVICE_API_URL + "v1/properties", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setPropertyList(response.data.data);
            });
        };
        fetchAllProperties();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const fetchDevices = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_DEVICE_API_URL + "v1/tuya-accounts", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);

                setAllData(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }
        fetchDevices();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        let fileredDataTemp = allData;

        if (filterData.searchKey !== "") {
            let inputVal = filterData.searchKey.toLowerCase();

            fileredDataTemp = fileredDataTemp.filter((item) => {
                const project_idMatch = item?.project_id?.toLowerCase().includes(inputVal);
                const uidMatch = item?.uid?.toLowerCase().includes(inputVal);
                const client_idMatch = item?.client_id?.toLowerCase().includes(inputVal);
                const client_secretMatch = item?.client_secret?.toLowerCase().includes(inputVal);
                const emailMatch = item?.email?.toLowerCase().includes(inputVal);
                const nameMatch = item?.name?.toLowerCase().includes(inputVal);
                const property_nameMatch = item?.property_name?.toLowerCase().includes(inputVal);
                const apt_nameMatch = item?.apt_name?.toLowerCase().includes(inputVal);

                return (project_idMatch || uidMatch || client_idMatch || client_secretMatch || emailMatch || nameMatch || property_nameMatch || apt_nameMatch);
            });
        }

        if (filterData.property !== "" && filterData.property !== "all") {
            fileredDataTemp = fileredDataTemp.filter((i) => i.property_id === filterData.property);
        }

        if (filterData.apartment !== "") {
            fileredDataTemp = fileredDataTemp.filter((i) => i.apt_id === filterData.apartment);
        }

        if (filterData.type !== "" && filterData.type !== "all") {
            fileredDataTemp = fileredDataTemp.filter((i) => i.type === filterData.type);
        }

        setFileredData(fileredDataTemp);
    }, [allData, filterData]);

    const onAdd = (data) => {
        setAllData(prev => {
            return [data].concat(prev);
        });
    }

    const onDeviceAdd = (data) => {
        console.log(1);
    }

    const confirmDelete = async () => {
        setShowDeleteModal(false);
        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(process.env.REACT_APP_DEVICE_API_URL + 'v1/tuya-accounts/' + selectedData?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setAllData(prev => {
                return prev?.filter(i => i?.id !== selectedData?.id);
            });

            let rData = response.data.data;

            let logData = {
                'title': 'An IoT account has been deleted',
                'description': [
                    'Project name: ' + rData?.name,
                    'Apartment: ' + rData?.property_name + ' - ' + rData?.apt_name
                ]
            }
            AddLogCallAPI(logData, token);
            setSelectedData(null);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onUpdate = (data) => {
        setSelectedData(null);

        setAllData(prev => {
            return prev?.map(i => {
                if (i?.id === data?.id)
                    return data;
                return i;
            });
        });
    }

    return (<>
        {loading && <Loader />}
        <Helmet title="Manage IoT Accounts" />

        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Manage IoT Account</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Smart Device</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Manage IoT Account</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    {contentLoading && (<div className="Loader TableLoader">
                        <TableLoader />
                    </div>)}

                    {!contentLoading && <div className="control-pane">
                        <div className={`${styles.Row}`}>

                            <AccountListFilter setShowTuyaAddFormNew={setShowTuyaAddFormNew.bind(this)} propertyList={propertyList} filterData={filterData} setFilterData={setFilterData.bind(this)} setPage={setPage.bind(this)} />

                            <div className={`${styles.NotesRow}`}>

                                {fileredData?.map((item, index) => {
                                    return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? <AccountListCard item={item} setShowDeleteModal={setShowDeleteModal.bind(this)} setSelectedData={setSelectedData.bind(this)} setShowTuyaEditFormNew={setShowTuyaEditFormNew.bind(this)} setShowAddFormNew={setShowAddFormNew.bind(this)} setApartmentData={setApartmentData.bind(this)} /> : null;
                                })}

                                {fileredData.length > 0 && (<div className="Pagination TablePaginationNew List">
                                    <TablePagination
                                        count={fileredData.length}
                                        color="primary"
                                        page={page}
                                        rowsPerPage={perPage}
                                        onPageChange={(e, v) => setPage(v)}
                                        rowsPerPageOptions={[
                                            { label: "4", value: 4 },
                                            { label: "8", value: 8 },
                                            { label: "16", value: 16 },
                                            { label: "All", value: -1 },
                                        ]}
                                        onRowsPerPageChange={(e) => {
                                            setPage(0);
                                            setPerPage(e.target.value);
                                        }}
                                        labelRowsPerPage={"Devices per Page:"}
                                    />
                                </div>)}


                                {fileredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                    <div className={`${styles.NoDataIMG}`}>
                                        <img src="/static/img/noDevice.svg" alt="No Data" />
                                    </div>
                                    <p className={`${styles.NoDataText}`}>Let's fill it up!</p>
                                    <p className={`${styles.NoDataTextSub}`}>List is Currently Empty.</p>
                                </div>)}
                            </div>

                        </div>
                    </div>}
                </div>
            </div>
        </div>

        <Dialog
            open={showDeleteModal}
            onClose={(e) => setShowDeleteModal(false)}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Would you like to delete this account?
                <button onClick={(e) => setShowDeleteModal(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <label className="PopupBodyText">The acoount information will be removed immediately. You can't undo this action.</label>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setShowDeleteModal(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={showTuyaAddFormNew}
            onClose={(e) => setShowTuyaAddFormNew(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm CustomWidthPops"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setShowTuyaAddFormNew(false)}><ArrowLeft /></button>
                Add IoT Account
                <button onClick={(e) => setShowTuyaAddFormNew(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <AddTuyaAccount setShowTuyaAddFormNew={setShowTuyaAddFormNew.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} onSubmitLocal={onAdd.bind(this)} propertyList={propertyList} />
            </DialogContent>
        </Dialog>

        <Dialog
            open={showTuyaEditFormNew}
            onClose={(e) => setShowTuyaEditFormNew(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm CustomWidthPops"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setShowTuyaEditFormNew(false)}><ArrowLeft /></button>
                Update IoT Account
                <button onClick={(e) => setShowTuyaEditFormNew(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <EditTuyaAccount setShowTuyaAddFormNew={setShowTuyaEditFormNew.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} onSubmitLocal={onUpdate.bind(this)} selectedData={selectedData} propertyList={propertyList} />
            </DialogContent>
        </Dialog>

        <Dialog
            open={showAddFormNew}
            onClose={(e) => { setShowAddFormNew(false); }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm CustomWidthPops"
        >
            <AddDeviceFormNew setShowAddFormNew={setShowAddFormNew.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} onSubmitLocal={onDeviceAdd.bind(this)} setLoading={setLoading.bind(this)} apartmentData={apartmentData} />
        </Dialog>

        <Footer />

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />
    </>)
}


export default withAuthenticationRequired(AccountList, {
    onRedirecting: () => <Loader />,
});
